<template>    
    <nav class="navbar navbar-expand navbar-light bg-white sticky-top shadow-sm py-1">
    <div class="container-fluid">
      <div class="collapse navbar-collapse">
        <div class="d-flex align-items-center ms-auto gap-2">
          <input
            type="text"
            v-model="searchText"
            class="form-control border border-success"
            placeholder="Zoekopdracht..."
            style="width: 250px; height: 34px; padding: 4px 8px; font-size: 14px; margin-top: -14px;"
          />
          <!-- Dropdown -->
          <div class="dropdown">
            <button
              class="btn btn-success btn-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style="height: 34px;"
            >
              <span class="pe-2">{{ selectedBreedName || $t('common.Select_breed') }}</span>              
            </button>
            <ul class="dropdown-menu dropdown-menu-end"> 
              <li @click="clearBreedSelection">
                <a class="dropdown-item" href="#">
                  {{ $t('common.Select_breed') }}
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>             
              <li
                v-for="breed in breeds"
                :key="breed.id"
                @click="selectBreed(breed)"
              >
                <a class="dropdown-item" href="#">{{ breed.name }}</a>
              </li>
            </ul>
          </div>
            
          <button style="height: 34px;" v-on:click="searchData" class="btn btn-sm bg-gradient-success  float-end">{{ $t('common.Search1') }}</button>

          <li class="nav-item dropdown d-flex align-items-center" :class="isRTL ? 'ps-2' : 'pe-2'">
            <a id="dropdownMenuButton" href="#" class="p-0 nav-link lh-1" :class="[color, showMenu ? 'show' : '']" data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu">
              <i class="material-symbols-rounded cursor-pointer"> notifications </i>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''" aria-labelledby="dropdownMenuButton">
              <li class="mb-2" v-for="notification in notifications" :key="notification.id" style="width: 300px;">
                <div class="p-2 bg-white rounded-lg shadow">
                  <div class="flex items-center gap-1 mb-1">
                    <h6 class="text-sm font-semibold">{{ notification.title }}</h6>
                    <small class="text-xs"> <i class="fa fa-clock me-1"></i> {{ notification.timeAgo }}</small>
                  </div>                  
                  <p class="mb-0 text-xs break-words whitespace-normal min-w-0">
                    {{ notification.message }}
                  </p>
                </div>
              </li>
            </ul>
          </li>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
    import {mapGetters} from 'vuex';
    import axios from 'axios'
    import '@fortawesome/fontawesome-free/css/all.min.css'

    export default {
        name: 'Nav_bar',
        data() {
            return {
              notifications:[],
              breeds:[],
              associationId: '',
              breedId: '',
              searchText: '',
              selectedBreedName: ''
            };
        },
        watch: {
          '$store.state.keeperAssociationId': {
            handler(val) {
              if (this.$store.state.roleName === 'Keeper' && val) {
                this.associationId = val;
                this.fetchAllBreedData();
                this.fetchAllNotificationData();
              }
            },
            immediate: true
          },
          '$store.state.associationAdminAssociationId': {
            handler(val) {
              if (this.$store.state.roleName === 'AssociationAdmin' && val) {
                this.associationId = val;
                this.fetchAllBreedData();
                this.fetchAllNotificationData();
              }
            },
            immediate: true
          }
        },        
        methods: {
            async fetchAllBreedData() {
                try {
                    const response = await axios.get(`breed/getbyassociation?associationId=${this.associationId}`);
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.breeds = result.data;
                    } else {
                        this.$showError('errors.Error_fetching_breeds');
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            async fetchAllNotificationData() {
                try {
                    const response = await axios.get(`notification/gettop?associationId=${this.associationId}`);
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.notifications = result.data;
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            selectBreed(breed) {
              this.breedId = breed.id;
              this.selectedBreedName = breed.name;
            },
            clearBreedSelection() {
              this.selectedBreedName = '';
              this.breedId = '';
            },
            async searchData() {

              const query = {
                associationId: this.associationId,
                searchText: this.searchText,
                breedId: this.breedId || ''
              };

              sessionStorage.setItem('searchQuery', JSON.stringify(query));

              if(this.searchText != '') {

                this.$router.push({
                  name: 'Search',
                  query
                });
            } else {
              this.$showError('errors.Search_text_required');
            }
          }
        },
        computed: {
            ...mapGetters(['user'])
        }
    }
</script>
<style scoped>
  .ripple, .ripple-effect {
    display: none !important;
  }
</style>